import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';


const Base_Url = process.env.REACT_APP_BASE_URL;
const UserProfile = ({ user }) => {
    return (
        <>
            <div className='user-details-container view-user'>
                <div className='details-container'>
                    <div className='profile-photo-container'>
                        <h3>Profile Photo</h3>
                        <div
                            className='profile-photo'
                        >
                            {user.profilePhoto ? <img src={`${Base_Url}/assets/profilePhotos/${user.profilePhoto}`} alt="Profile" /> : <FontAwesomeIcon icon={faPlus} />}
                        </div>
                        <div>
                            <h3>Name : {user.firstName + " " + user.lastName}</h3>
                            <h3>Country : {user.country}</h3>
                            <h3>State : {user.state}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default UserProfile;
